
import "./Question-card.scss";
import { useEffect, useRef, useState } from "react";
import { StopWatchActions, TestTypes } from '@Constants/app.constant';
import { toast } from "react-hot-toast";
import { MathJax } from "better-react-mathjax";
import SvgIcon from '@Components/icons/SvgIcon';
import { formatMultipleChoiceSelection, isOptionSelected } from '../../../utils/questionUtils';
import { TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { Tooltip } from "react-tooltip";
export const QuestionCardIndex = ({ question, index, total, testType, testId, onClickSubmitionHandler, updateTestQuestionHandler, actionStopWatch, isTestSeries, onClickMarkForReview, pendingQuestionsCount = 0 }: any) => {

    const options = Object.entries(question?.Options || {});
    const displayedQuestionNumber = typeof question?.QuestionNumber === 'number'
        ? question.QuestionNumber
        : pendingQuestionsCount > 0
            ? pendingQuestionsCount + index + 1
            : index + 1;
    const [selectedOption, setSelectedOption] = useState('');
    const [flag, setFlag] = useState(false);
    const questionRef = useRef<any>(null)
    const answerRef = useRef<any>(null)
    const questionCardRef = useRef<any>(null)
    const [hintVisible, setHintVisible] = useState(false);
    const executeQuestionScroll = () => questionRef.current.scrollIntoView()
    const executeAnswerScroll = () => answerRef.current.scrollIntoView()
    const [previousSelectedOption, setPreviousSelectedOption] = useState<string>(question.SelectedOption);
    const [inputValue, setInputValue] = useState(question.SelectedOption || '');
    const examType1 = window.location.pathname.includes(TestSereisRouteURL.FULL_MOCK_TEST_SERIES);
    const examType2 = window.location.pathname.includes(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES);

    useEffect(() => {
        setPreviousSelectedOption(question.SelectedOption);
        setSelectedOption(question.SelectedOption);
        setInputValue(question.SelectedOption || '');
        setFlag(question.IsFlag);
        setHintVisible(false);
    }, [index]);

    const onClickMultipleOption = (option: string) => {
        let previouslySelectedOption = selectedOption;
        setPreviousSelectedOption(previouslySelectedOption);

        // Use utility function to format selection
        const selectionOption = formatMultipleChoiceSelection(selectedOption, option);
        setSelectedOption(selectionOption);
        let params: any = {
            "UserTestId": question.UserTestId,
            "QuestionId": question.QuestionId,
            "SelectedOption": selectionOption,
            "IsFlag": question.IsFlag,
            'previousSelectedOption': previouslySelectedOption
        }
        if (testType == TestTypes.speed) {
            if (isTestSeries) {
                params["examId"] = testId;
            } else {
                params["testId"] = testId;
            }
            params["difficultyLevel"] = question.Difficult;
            updateTestQuestionHandler(params);
            onClickSubmitionHandler(params);
        } else {
            updateTestQuestionHandler(params);
            onClickSubmitionHandler(params);
        }
    }

    const onClickOption = (option: string) => {
        let previouslySelectedOption = selectedOption;
        setPreviousSelectedOption(previouslySelectedOption);
        setSelectedOption(option);
        let params: any = {
            "UserTestId": question.UserTestId,
            "QuestionId": question.QuestionId,
            "SelectedOption": option === '' ? null : option,
            "IsFlag": question.IsFlag,
            'previousSelectedOption': previouslySelectedOption
        }
        if (testType == TestTypes.speed) {
            if (isTestSeries) {
                params["examId"] = testId;
            } else {
                params["testId"] = testId;
            }
            params["difficultyLevel"] = question.Difficult;
            onClickSubmitionHandler(params)
            updateTestQuestionHandler(params);
        } else {
            updateTestQuestionHandler(params);
            onClickSubmitionHandler(params);
        }
    }

    const onInputChange = (value: string) => {
        setInputValue(value);
        if (testType == TestTypes.speed) {
            let params: any = {
                "UserTestId": question.UserTestId,
                "QuestionId": question.QuestionId,
                "SelectedOption": value === '' ? null : value,
                "IsFlag": question.IsFlag,
                'previousSelectedOption': selectedOption
            }
            if (isTestSeries) {
                params["examId"] = testId;
            } else {
                params["testId"] = testId;
            }
            params["difficultyLevel"] = question.Difficult;
            onClickSubmitionHandler(params);
            updateTestQuestionHandler(params);
        }
    }

    const onClickFlag = (flag: boolean) => {
        let params: any = {
            "UserTestId": question.UserTestId,
            "QuestionId": question.QuestionId,
            "SelectedOption": selectedOption,
            "IsFlag": flag,
            'previousSelectedOption': previousSelectedOption
        }
        setFlag(flag);
        if (testType == TestTypes.speed) {
            if (isTestSeries) {
                params["examId"] = testId;
            } else {
                params["testId"] = testId;
            }
            params["difficultyLevel"] = question.Difficult;
            onClickSubmitionHandler(params)
        } else {
            updateTestQuestionHandler(params);
            onClickSubmitionHandler(params);
            onClickMarkForReview(params);
        }
    }

    useEffect(() => {
        executeQuestionScroll();
    }, [question])
    const formatScore = (value: any) => {
        const num = Number(value);
        if (isNaN(num)) return 0;
        return num % 1 === 0 ? num : num.toFixed(2);
    };

    return (
        <>

            <div id={`questioncard_${question.QuestionId}`} ref={questionCardRef} className="qust-page-card">
                <div className="qust-anst-card tw-flex tw-items-center">
                    <div>
                        <span onClick={executeQuestionScroll} data-tooltip-id="question" data-tooltip-content="Scroll to question" className="qust-span cursor-pointer">Q</span>
                          <Tooltip id="question" place="right" style={{ fontSize: '12px', padding: '4px 8px' }} />
                        <span onClick={executeAnswerScroll} data-tooltip-id="answer" data-tooltip-content="Scroll to answer" className="ans-span cursor-pointer">A</span>
                          <Tooltip id="answer" place="right" style={{ fontSize: '12px', padding: '4px 8px' }} />

                    </div>
                    <span className="tw-flex1 ml-3">
                        <span className="qust-num">Question: {displayedQuestionNumber}
                            {testType == TestTypes.regular ? `/${total}` : ''}
                        </span>
                    </span>
                    <span className="marks-span">Marks: <span className="ngvt-mark-span"> +{formatScore(question.PositiveMark)} | {question.NegativeMark > 0 ? - formatScore(question.NegativeMark) : formatScore(question.NegativeMark)}</span></span>
                    <span className={`qust-subjct ${question.SubjectName.toUpperCase()==="MATHS"? "bg-blue-100 border border-blue-500":question.SubjectName.toUpperCase()==="PHYSICS"? "bg-green-100 border border-green-500":question.SubjectName.toUpperCase()==="CHEMISTRY"?"bg-pink-100 border border-pink-500":question.SubjectName.toUpperCase()==="BIOLOGY"?"bg-yellow-100 border border-yellow-500": "bg-purple-100 border border-purple-500"}`}><b>{question.SubjectName}</b></span>
                    {
                        question.TopicName && <span className="qust-subjct bg-purple-100 border border-purple-500"><b>{question.TopicName}</b></span>
                    }
                    {
                        question.SecondTopicName && (question.SecondTopicName !== question.TopicName) && <span  className="qust-subjct bg-blue-100 border border-blue-500"><b>{question.SecondTopicName}</b></span>
                    }



                </div>

                {/* <div className="qust-marks-card">
                    <div className="tw-flex">
                        <span className="qust-num"><b>Question:</b> {index + 1}
                            {testType == TestTypes.regular ? `/${total}` : ''}
                        </span>
                        <span>
                        </span>
                    </div>
                    <div>
                        <span className="marks-span"><b>Marks:</b> <span className="ngvt-mark-span"> +{question.PositiveMark} | {question.NegativeMark > 0 ? -question.NegativeMark : question.NegativeMark}</span></span>
                    </div>

                </div> */}

                <div className="qust-main-card">
                    <div className="main-qust-card">
                        {/* {testType == TestTypes.regular && question.QuestionTypeId == 3 && (
                            <div style={{ fontSize: '12px', marginBottom: '10px', fontStyle: 'italic', fontWeight: '500' }}>
                                (Please answer any 5 numeric questions)
                            </div>
                        )} */}
                        <div id={`question_${question.QuestionId}`} ref={questionRef} className="main-qust" ></div>
                        <MathJax dangerouslySetInnerHTML={{ __html: question.Question }} dynamic={true} >
                        </MathJax>
                        {
                            (question?.QuestionYear!==null && question?.QuestionYear!==0 && question.BoardName) && <div className="tw-font-bold tw-mt-2 tw-text-sm">
                                {`[${question?.BoardName} - ${question?.QuestionYear}]`}
                            </div>
                        }
                        {question.QuestionTypeId === 2 && (
                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', marginTop: '10px', fontStyle: 'italic' }}>
                                (There can be multiple answers for this question)
                            </div>
                        )}

                        <div id={`answer${question.QuestionId}`} ref={answerRef} className="qust-options-card">
                            {
                                question.QuestionTypeId == 3 ?
                                    <div className="w-100">
                                        <input
                                            type="text"
                                            className="input-answer"
                                            value={inputValue}
                                            onChange={(e) => onInputChange(e.target.value)}
                                            onBlur={(e) => onClickOption(e.target.value)}
                                            placeholder="Enter your answer"
                                        />
                                    </div>
                                    :
                                    question.QuestionTypeId == 2 ?
                                        options.map((option: any) => {
                                            const isSelected = isOptionSelected(selectedOption, option[0]);
                                            return (
                                                option[1] ? <div onClick={() => onClickMultipleOption(option[0])} key={option[0]}
                                                    className={`opt-div tw-items-center flex ${isSelected ? "active-selected" : ""}`}>
                                                    <span className="alpb-opt" dangerouslySetInnerHTML={{ __html: option[0] }} ></span>
                                                    <span className="opt-label">
                                                        <MathJax dangerouslySetInnerHTML={{ __html: option[1] }} dynamic={true} >
                                                        </MathJax>
                                                    </span>
                                                </div> : ''
                                            )
                                        })
                                        :
                                        question.QuestionTypeId == 1 ?
                                            options.map((option: any) => {
                                                return (
                                                    option[1] ? <div onClick={() => onClickOption(option[0])} key={option[0]}
                                                        className={`opt-div tw-items-center flex ${(option[0] == selectedOption) ? "active-selected" : ""}`}>
                                                        <span className="alpb-opt" dangerouslySetInnerHTML={{ __html: option[0] }} ></span>
                                                        <span className="opt-label">
                                                            <MathJax dangerouslySetInnerHTML={{ __html: option[1] }} dynamic={true} >
                                                            </MathJax>
                                                        </span>
                                                    </div> : ''
                                                )
                                            })
                                            :
                                            question.IsMultiple == 1 ?
                                                options.map((option: any) => {
                                                    return (

                                                        option[1] ? <div onClick={() => onClickMultipleOption(option[0])} key={option[0]}
                                                            className={`opt-div tw-items-center flex ${(selectedOption && (selectedOption.includes(option[0]))) ? "active-selected" : ""}`}>
                                                            <span className="alpb-opt" dangerouslySetInnerHTML={{ __html: option[0] }} ></span>
                                                            <span className="opt-label">
                                                                <MathJax dangerouslySetInnerHTML={{ __html: option[1] }} dynamic={true} >
                                                                </MathJax>
                                                            </span>
                                                        </div> : ''
                                                    )
                                                })
                                                : options.map((option: any) => {
                                                    return (
                                                        option[1] ? <div onClick={() => onClickOption(option[0])} key={option[0]}
                                                            className={`opt-div tw-items-center flex ${(option[0] == selectedOption) ? "active-selected" : ""}`}>
                                                            <span className="alpb-opt" dangerouslySetInnerHTML={{ __html: option[0] }} ></span>
                                                            <span className="opt-label">
                                                                <MathJax dangerouslySetInnerHTML={{ __html: option[1] }} dynamic={true} >
                                                                </MathJax>
                                                            </span>
                                                        </div> : ''
                                                    )
                                                })
                            }
                        </div>
                    </div>
                    {(question.Hint && question.Hint.toLowerCase() !== 'null' && question.Hint.trim() !== '') && !examType1 && !examType2 && (
                        <div className="tw-mb-5 tw-mt-5">
                            <button
                                className="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-text-gray-600 tw-font-medium"
                                onClick={() => setHintVisible(!hintVisible)}
                            >
                                Hint
                                <SvgIcon name="info" size={16} color="#7A68E0" className="tw-mt-[1px]" />
                            </button>
                            {hintVisible && (
                                <div className="tw-mt-2 tw-p-4 tw-bg-purple-50 tw-border tw-border-purple-100 tw-rounded-lg tw-relative tw-animate-fade-in">
                                    <button
                                        className="tw-absolute tw-top-2 tw-right-2 tw-text-purple-400 hover:tw-text-purple-600"
                                        onClick={() => setHintVisible(false)}
                                    >
                                        <SvgIcon name="cross" size={14} />
                                    </button>
                                    <div className="tw-text-sm tw-text-gray-700">
                                        {/* <div dangerouslySetInnerHTML={{ __html: question.Hint }} /> */}
                                        <MathJax dangerouslySetInnerHTML={{ __html: question.Hint?.replace(/\r\n/g, '\n') }} dynamic={true} >
                                        </MathJax>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="response-marked-card">
                        <div>
                            <button className="ia-btn ia-btn-outline-primary" onClick={() => {
                                if (question.QuestionTypeId == 3) {
                                    setInputValue('');
                                    onClickOption('');
                                } else {
                                    onClickOption('');
                                }
                            }}  >Clear Response</button>
                        </div>
                        <div>
                            {testType == TestTypes.speed ? '' :
                                flag ? <button className="ia-btn ia-btn-primary" onClick={() => onClickFlag(false)}  >Marked For Review</button> : <button className="ia-btn ia-btn-primary" onClick={() => onClickFlag(true)}  >Mark For Review</button>
                            }
                        </div>
                    </div>

                </div>

            </div>

        </>
    )
}